import { render, staticRenderFns } from "./PeriodsByPadrilloModal.vue?vue&type=template&id=bf2f96ce"
import script from "./PeriodsByPadrilloModal.vue?vue&type=script&lang=js"
export * from "./PeriodsByPadrilloModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports